import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const NeonMeshBackground = () => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Mesh points
    const points = [];
    const numPoints = 8;
    
    // Initialize points
    for (let i = 0; i < numPoints; i++) {
      for (let j = 0; j < numPoints; j++) {
        points.push({
          x: (canvas.width / (numPoints - 1)) * i,
          y: (canvas.height / (numPoints - 1)) * j,
          originalX: (canvas.width / (numPoints - 1)) * i,
          originalY: (canvas.height / (numPoints - 1)) * j,
          offsetX: 0,
          offsetY: 0,
          time: Math.random() * Math.PI * 2
        });
      }
    }

    const animate = (timestamp) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // Update points with wave motion
      points.forEach((point, index) => {
        point.time += 0.02;
        point.offsetX = Math.sin(point.time + index * 0.1) * 30;
        point.offsetY = Math.cos(point.time + index * 0.15) * 20;
        point.x = point.originalX + point.offsetX;
        point.y = point.originalY + point.offsetY;
      });

      // Draw mesh
      ctx.strokeStyle = 'rgba(0, 255, 255, 0.3)';
      ctx.lineWidth = 1;
      ctx.shadowColor = '#00ffff';
      ctx.shadowBlur = 10;

      // Horizontal lines
      for (let i = 0; i < numPoints; i++) {
        ctx.beginPath();
        for (let j = 0; j < numPoints; j++) {
          const point = points[i * numPoints + j];
          if (j === 0) {
            ctx.moveTo(point.x, point.y);
          } else {
            ctx.lineTo(point.x, point.y);
          }
        }
        ctx.stroke();
      }

      // Vertical lines
      for (let j = 0; j < numPoints; j++) {
        ctx.beginPath();
        for (let i = 0; i < numPoints; i++) {
          const point = points[i * numPoints + j];
          if (i === 0) {
            ctx.moveTo(point.x, point.y);
          } else {
            ctx.lineTo(point.x, point.y);
          }
        }
        ctx.stroke();
      }

      // Draw glowing nodes
      points.forEach(point => {
        ctx.beginPath();
        const gradient = ctx.createRadialGradient(point.x, point.y, 0, point.x, point.y, 8);
        gradient.addColorStop(0, 'rgba(0, 255, 255, 0.8)');
        gradient.addColorStop(1, 'rgba(0, 255, 255, 0)');
        ctx.fillStyle = gradient;
        ctx.arc(point.x, point.y, 8, 0, Math.PI * 2);
        ctx.fill();
      });

      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return (
    <div className="fixed inset-0 z-0">
      <canvas
        ref={canvasRef}
        className="absolute inset-0 w-full h-full"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-blue-900/20 to-cyan-900/20" />
    </div>
  );
};

export default NeonMeshBackground;